/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { skipAutoDateConversion } from '../../../api-dates';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleName as SecurityRoleName } from '../../models/security/role-name';

export interface RemoveUserFromRole$Params {
  userId: string;
  roleName: SecurityRoleName;
}

export function removeUserFromRole(http: HttpClient, rootUrl: string, params: RemoveUserFromRole$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, removeUserFromRole.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('roleName', params.roleName, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context: skipAutoDateConversion(context) })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

removeUserFromRole.PATH = '/users/{userId}/role/{roleName}';

